import { defineComponent as _defineComponent } from 'vue'
import { getAvailableRoutes } from "@/router";
import { ref } from "vue";
import router from "@/router";

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuPanel',
  setup(__props, { expose: __expose }) {
  __expose();

let routes = router.currentRoute.value.meta.menuSingle ? [router.currentRoute.value] : getAvailableRoutes();
const group = router.currentRoute.value.meta.group;
const groupedRoutesCount = group ? routes.filter((route) => route.meta.group == group).length : 1;
if (groupedRoutesCount > 1) {
  routes = getAvailableRoutes().filter((r) => r.meta.group === group);
} else {
  routes = [];
}
const activeIndex = ref(window.location.pathname);

const __returned__ = { get routes() { return routes }, set routes(v) { routes = v }, group, groupedRoutesCount, activeIndex }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})